/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2025-05-06 16:38:47
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-05-07 13:59:14
 */
import service from '@/utils/request'

// 列表数据查询
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/aiModelRecord/list',
    data: params
  })

// 编辑
export const editSetting = (params: any) =>
  service.request({
    method: 'post',
    url: '/aiModelRecord/edit',
    data: params
  })

// 新增
export const addSetting = (params: any) =>
  service.request({
    method: 'post',
    url: '/aiModelRecord/add',
    data: params
  })
